import type { SvgIconTypeMap } from '@mui/material';
import type { OverridableComponent } from '@mui/material/OverridableComponent';
import { AuthRolesEnum } from './authRoles';

export interface DaMenuItem {
  label: string;
  path: string;
  icon: OverridableComponent<SvgIconTypeMap>| undefined;
  menuItems?: Array<DaMenuItem>;
  /**
   * Optional array of role strings that are allowed to see this menu item.
   * If not provided, the item will be visible to all authenticated users.
   * Note - Uses the same role strings as defined in AuthRolesEnum.
   */
  allowedRoles?: Array<string>;
};

export const MainMenuData: (userHasPrivilege: (authPrivileges: Array<string>) => boolean)
  => DaMenuItem[] = (userHasPrivilege: (authPrivileges: Array<string>) => boolean) => [
  {
    label: 'PAFs',
    path: '/pafs',
    icon: undefined,
    allowedRoles: []
  },
  {
    label: 'Companies',
    path: '/companies',
    icon: undefined,
    allowedRoles: [AuthRolesEnum.Licensee]
  },
  {
    label: 'Brokers',
    path: '/brokers',
    icon: undefined,
    menuItems: [
      {
        label: 'Season',
        path: '/Schedule/Season',
        icon: undefined,
      },
      {
        label: 'Weekly',
        path: '/Schedule/Weekly',
        icon: undefined,
      }
    ],
    allowedRoles: [AuthRolesEnum.Licensee, AuthRolesEnum.ListOwner, AuthRolesEnum.ListAdmin]
  },
  {
    label: 'Licensees',
    path: '/licensees',
    icon: undefined,
    menuItems: [
      {
        label: 'Standings',
        path: '/Results/Standings',
        icon: undefined,
      },
      {
        label: 'Skins',
        path: '/Results/Skins',
        icon: undefined,
      }
    ],
    allowedRoles: [AuthRolesEnum.Licensee]
  },
  {
    label: 'Users',
    path: '/users',
    icon: undefined,
    allowedRoles: [AuthRolesEnum.Licensee, AuthRolesEnum.ListOwner]
  },
];

